module.exports = __webpack_public_path__ + "assets/GoldEpsilon2x.240e0e3e8d53b37f6427cbbe7dc6d9cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs2x-gold/GoldEpsilon2x.png
// module id = 808
// module chunks = 0